import React from 'react';

// Define a functional component that takes count and label as props
const ToDoCount = ({ count, label, backgroundColor = '#007bff', color = '#fff', onClick, active  }) => {
    // return (
    //     <div style={{ ...styles.container, backgroundColor: backgroundColor, color: color }}>
    //         <div style={styles.count}>{count}</div>
    //         <div style={styles.label}>{label}</div>
    //     </div>
    // );

        return (
            <div
            onClick={onClick}
            role={onClick ? "button" : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={(e) => {
                if (!onClick) return;
                if (e.key === "Enter" || e.key === " ") onClick();
            }}
            style={{
                cursor: onClick ? "pointer" : "default",
                userSelect: "none",
                margin: "10px",
                padding: "18px 22px",
                borderRadius: "10px",
                minWidth: "160px",
                backgroundColor: backgroundColor || "#ddd",
                outline: active ? "3px solid rgba(0,0,0,0.25)" : "none",
                transform: active ? "scale(1.02)" : "none",
            }}
            title={onClick ? `Filter: ${label}` : ""}
            >
            <div style={{ fontSize: 28, fontWeight: 700 }}>{count}</div>
            <div style={{ fontSize: 14 }}>{label}</div>
            {active && <div style={{ fontSize: 12, marginTop: 6 }}>(filtered)</div>}
            </div>
        );

};

// Styles for the CountBox component
// const styles = {
//     container: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         width: '150px',
//         height: '100px',
//         borderRadius: '8px',
//         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
//         margin: '10px',
//     },
//     count: {
//         fontSize: '2rem',
//         fontWeight: 'bold',
//     },
//     label: {
//         fontSize: '1rem',
//         marginTop: '5px',
//     },
// };

export default ToDoCount;